/* eslint-disable */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { compose, graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { Link } from 'react-router-dom';
import CopyToClipboard from 'react-copy-to-clipboard';
import {
  Table,
  Dropdown,
  Button,
  Modal,
  Divider,
  Form
} from 'semantic-ui-react';
import _ from 'lodash';

import * as AppActions from '../../actions';
import months from '../../utils/months';
import { getYear } from '../../utils/dates';
import { getAccounts } from '../../services/AccountService';
import { getCampaigns } from '../../fbApi/Campaign';
import { creds } from '../../config/FBAdOps';

class AdAccountList extends Component {
  state = {
    data: null,
    accounts: null,
    paging: null,
    summary: null,
    maxAccounts: 50,
    listedAccounts: 50,
    filteredAccounts: null,
    generatedUrl: '',
    showModal: false,
    showCopySection: false,
    showGenerateSection: false,
    monthsOptions: [],
    weeksOptions: [],
    years: [],
    selectedMonth: null,
    selectedWeeks: 7,
    selectedYear: null,
    selectedAccounts: [],
    enableButton: false,
    modalButtonText: '',
    modalButtonTitle: '',
    campaigns: [],
    shareLink: null,
    campaignIds: [],
    campaignMonthName: '',
    presentationSaved: null,
    doneLoading: false,
    previews: [],
    presentation: {
      url: null,
      data: {}
    },
    campaignObjective: null,
    campaignMonth: {
      PRODUCT_CATALOG_SALES: [],
      LEAD_GENERATION: [],
      VIDEO_VIEWS: [],
      LINK_CLICKS: [],
      CONVERSIONS: [],
      MESSAGES: [],
      POST_ENGAGEMENT: [],
      OUTCOME_TRAFFIC: [],
      OUTCOME_SALES: []
    },
    token: this.props.getFbToken()
  };

  componentDidMount() {
    this.fillYears();
    this.fillMonths();
    this.fillWeeks();
    this.props.setSectionTitle('Accounts');
    this.props.saveGTMEvent('Accounts', 'Accounts');
    this.getAdAccounts();
  }

  getAdAccounts = async () => {
    try {
      const result = await getAccounts();

      this.setState({
        data: result,
        accounts: _.sortBy([...result], 'name'),
        filteredAccounts: _.sortBy([...result], 'name'),
        totalAccounts: result.length
      });
    } catch (error) {
      alert(error);
    }
  };

  getSelectedAccounts = () => {
    const selectedAccounts = {
      accountIds: [],
      accountNames: []
    };
    _.sortBy([...this.state.selectedAccounts], 'name').forEach((account) => {
      selectedAccounts.accountIds.push(account.value);
      selectedAccounts.accountNames.push(
        account.name +
          ' ' +
          this.state.selectedMonth +
          getYear(this.state.selectedMonth)
      );
    });

    return selectedAccounts;
  };

  fillMonths = () => {
    const monthsOpts = _.map(months, (op, index) => ({
      key: index,
      value: op.monthName,
      text: op.monthName
    }));

    this.setState({
      monthsOptions: monthsOpts
    });
  };

  fillWeeks = () => {
    const weeks = [
      { name: '1 week', value: 7 },
      { name: '2 weeks', value: 14 },
      { name: '3 weeks', value: 21 },
      { name: '4 weeks', value: 28 },
      { name: '3 months', value: 90 },
      { name: '6 months', value: 180 }
    ];
    const weeksOpts = _.map(weeks, (op, index) => ({
      key: index,
      value: op.value,
      text: op.name
    }));

    this.setState({
      weeksOptions: weeksOpts
    });
  };

  fillYears = () => {
    const baseYear = 2017;
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = baseYear; year <= currentYear; year++) {
      years.push({
        value: year,
        text: year
      });
    }
    this.setState({
      years
    });
  };

  onCloseForm = (event) => {
    event.preventDefault();
    this.setState({
      showModal: false,
      copied: false
    });
  };

  onYearSelect = (event, data) => {
    const enableButton =
      data.value &&
      this.state.selectedMonth &&
      this.state.selectedAccounts.length > 0;

    this.setState({
      selectedYear: data.value,
      enableButton
    });
  };

  onMonthSelect = (event, data) => {
    const enableButton =
      data.value &&
      this.state.selectedYear &&
      this.state.selectedAccounts.length > 0;

    this.setState({
      selectedMonth: data.value,
      enableButton
    });
  };

  onWeekSelect = (event, data) => {
    this.setState({
      selectedWeeks: data.value
    });
  };

  filterAccounts = (event) => {
    const value = event.target.value;
    let accounts = this.state.accounts;
    let maxAccounts = 50;

    if (value !== '') {
      accounts = this.state.accounts.filter((val) => {
        return val.name.toLowerCase().indexOf(value.toLowerCase()) !== -1;
      });

      if (accounts.length < 50) {
        maxAccounts = accounts.length;
      }
    }

    this.setState({
      filteredAccounts: accounts,
      totalAccounts: accounts.length,
      listedAccounts: accounts.length,
      maxAccounts
    });
  };

  onAccountSelect = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    if (event.target.checked) {
      this.setState({
        selectedAccounts: [
          ...this.state.selectedAccounts,
          {
            name,
            value
          }
        ],
        enableButton: this.state.selectedMonth && this.state.selectedYear
      });
    } else {
      const totalAccounts = this.state.selectedAccounts.length;
      this.setState((prevState) => {
        return {
          selectedAccounts: prevState.selectedAccounts.filter((val) => {
            return val.value !== value;
          })
        };
      });

      const enableButton =
        this.state.selectedMonth &&
        this.state.selectedYear &&
        totalAccounts > 1;
      this.setState({
        enableButton
      });
    }
  };

  onCopy = () => {
    this.setState({
      copied: true
    });
  };

  enableModal = async () => {
    this.setState({
      showModal: true,
      copied: false,
      showCopySection: false,
      showGenerateSection: true,
      doneLoading: false,
      modalButtonText: 'Press Here to Generate Share Link',
      modalButtonTitle: "You're about to share",
      campaigns: [],
      campaignMonth: {
        PRODUCT_CATALOG_SALES: [],
        LEAD_GENERATION: [],
        VIDEO_VIEWS: [],
        LINK_CLICKS: [],
        CONVERSIONS: [],
        MESSAGES: [],
        POST_ENGAGEMENT: []
      }
    });

    const allCampaigns = await Promise.all(
      _.map(this.state.selectedAccounts, async (val) => {
        const campaigns = await this.getCampaigns(val.value);
      })
    );

    this.setState({
      doneLoading: true
    });
  };

  generateUrl = () => {
    var i,
      url,
      urlArray = [],
      chars = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(
        ''
      );
    for (i = 0; i < 32; i++) {
      urlArray.push(chars[Math.floor(Math.random() * 66)]);
    }
    url = urlArray.join('');
    return url;
  };

  getCampaigns = async (id) => {
    this.setState({
      campaignIds: []
    });

    try {
      const campaigns = await getCampaigns(id, this.state.token);
      const result = campaigns.data;

      var assocCampaigns = [];
      var campaignMonths = [];
      let years = [];

      _.map(_.reverse(_.sortBy([...result], 'start_time')), (campaign) => {
        const firstPart = campaign.name.split('_')[0];
        const year =
          firstPart.length === 4
            ? firstPart
            : firstPart.substring(firstPart.length - 4, firstPart.length);
        const month =
          firstPart.length === 4
            ? campaign.name.split('_')[1]
            : firstPart.substring(0, firstPart.length - 4);
        assocCampaigns[year + month] = {
          month_year: null,
          ids: []
        };
      });
      _.map(_.reverse(_.sortBy([...result], 'start_time')), (campaign) => {
        const firstPart = campaign.name.split('_')[0];
        const year =
          firstPart.length === 4
            ? firstPart
            : firstPart.substring(firstPart.length - 4, firstPart.length);
        const month =
          firstPart.length === 4
            ? campaign.name.split('_')[1]
            : firstPart.substring(0, firstPart.length - 4);

        const existentYear = years.filter((item) => {
          return item.text === year;
        });

        if (existentYear.length === 0) {
          years.push({
            value: year,
            text: year
          });
        }

        assocCampaigns[year + month].month = month;
        assocCampaigns[year + month].year = year;
        assocCampaigns[year + month].ids.push(campaign.id);
      });

      _.mapKeys(assocCampaigns, (assocCampaign) => {
        if (assocCampaign) {
          campaignMonths.push(assocCampaign);
        }
      });

      const campaignOpts = _.map(campaignMonths, (op, index) => {
        const month = months.filter((item) => {
          return item.shortName === op.month;
        });

        return {
          key: index,
          value: op.ids.join(','),
          text: month[0] ? month[0].monthName : op.month,
          accountId: id,
          year: op.year
        };
      });

      this.setState({
        data: result,
        campaigns: this.state.campaigns.concat(campaignOpts)
      });
    } catch (error) {
      console.log(error);
    }
  };

  generatePresentation = async () => {
    const { campaignMonth } = this.state;

    const filteredCampains = this.state.campaigns.filter((val) => {
      return (
        val.year == this.state.selectedYear &&
        val.text == this.state.selectedMonth
      );
    });

    const selectedAccounts = this.getSelectedAccounts();

    const presentationData = {};
    const presentation = this.state.presentation;
    presentationData.campaigns = campaignMonth;
    presentationData.title = selectedAccounts.accountNames.join(',');
    presentation.url = this.generateUrl();
    presentation.data = JSON.stringify(presentationData);
    presentation.username = this.props.user.email;
    presentation.active = true;
    presentation.cachedquery = JSON.stringify({
      account_id: this.state.selectedAccounts,
      month_year: this.state.selectedMonth + this.state.selectedYear,
      campaign_ids: filteredCampains,
      is_multiple_accounts: true
    });

    let expirationDate = new Date();
    const days = this.state.selectedWeeks;
    expirationDate.setDate(expirationDate.getDate() + days);
    presentation.createdAt = new Date();
    presentation.updatedAt = new Date();
    presentation.expiredAt = expirationDate.toISOString().split('T')[0];
    presentation.name = selectedAccounts.accountNames.join(',');
    this.setState({
      presentation: presentation
    });

    try {
      await this.props.submit(this.state.presentation);
      this.setState({
        presentationSaved: 'new',
        shareLink: this.presentation.url
      });
    } catch (error) {
      const updatedPresentation = await this.props.update(
        this.state.presentation
      );
      this.setState({
        presentationSaved: 'update',
        showModal: true,
        shareLink:
          updatedPresentation.data.updatePresentationByName.presentation.url
      });
    }
  };

  generateShareLinks = async () => {
    await this.generatePresentation();
    let urlString =
      this.state.shareLink !== null
        ? (urlString = window.location + '/' + this.state.shareLink)
        : '';
    urlString = urlString
      .replace('accounts', 'presentations')
      .replace('list', 'detail');
    this.setState({
      generatedUrl: urlString,
      showCopySection: true,
      showGenerateSection: false,
      modalButtonText: 'Copy to Clipboard',
      modalButtonTitle: '1-Week Share link Created for',
      campaignMonthName: this.state.selectedMonth + this.state.selectedYear
    });
  };

  isAccountChecked = (id) => {
    const account = this.state.selectedAccounts.filter((val) => {
      return val.value === id;
    });

    return account.length > 0;
  };

  renderList = () => {
    const { filteredAccounts } = this.state;
    return filteredAccounts ? (
      <div>
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>
                Year
                <div className="select-months select-years">
                  <Dropdown
                    placeholder="Year"
                    search
                    selection
                    options={this.state.years}
                    onChange={this.onYearSelect}
                  />
                </div>
                Month
                <div className="select-months">
                  <Dropdown
                    placeholder="Month"
                    search
                    selection
                    options={this.state.monthsOptions}
                    onChange={this.onMonthSelect}
                  />
                </div>
                <div className="select-months">
                  <Dropdown
                    placeholder="Expiration"
                    selection
                    defaultValue={7}
                    options={this.state.weeksOptions}
                    onChange={this.onWeekSelect}
                  />
                </div>
                <div className="select-months">
                  <Button
                    disabled={!this.state.enableButton}
                    className="floated left tiny grey"
                    onClick={() => this.enableModal()}
                  >
                    Share Clients
                  </Button>
                </div>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <Table.Row>
              <Table.Cell>
                <b>Client</b>{' '}
                <div className="ui input div-search">
                  <input
                    className="input-search"
                    type="text"
                    placeholder="Search..."
                    onChange={this.filterAccounts}
                  />
                </div>
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <div className="div-accounts">
                  {filteredAccounts.map((account) => (
                    <Table.Row key={account.account_id}>
                      <Table.Cell>
                        <input
                          onChange={this.onAccountSelect}
                          defaultChecked={this.isAccountChecked(
                            account.account_id
                          )}
                          className="select-account"
                          type="checkbox"
                          name={account.name}
                          value={account.account_id}
                        />
                        <Link to={`/accounts/${account.account_id}`}>
                          {account.name}
                        </Link>
                      </Table.Cell>
                    </Table.Row>
                  ))}
                </div>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell colSpan="3" />
            </Table.Row>
          </Table.Footer>
        </Table>
        <Modal
          dimmer={'inverted'}
          open={this.state.showModal}
          onClose={this.onCloseForm}
        >
          <Modal.Header>Share Presentations</Modal.Header>
          <Modal.Content>
            <div>
              <p>{this.state.modalButtonTitle}</p>
              <p>{`${this.state.selectedMonth} ${this.state.selectedYear}`}</p>
              <ul>
                {this.state.selectedAccounts.map((account) => {
                  return <li key={account.value}>{account.name}</li>;
                })}
              </ul>
              {this.state.showCopySection ? (
                <div>
                  <a href={this.state.generatedUrl} target="_new">
                    {this.state.generatedUrl}
                  </a>
                  <CopyToClipboard
                    text={this.state.generatedUrl}
                    onCopy={this.onCopy}
                  >
                    <Form.Button size="small" floated="right">
                      Copy
                    </Form.Button>
                  </CopyToClipboard>
                  <Divider hidden />
                  {this.state.copied ? <span>Copied</span> : null}
                </div>
              ) : null}
              {!this.state.doneLoading ? <label>Loading...</label> : null}
              {this.state.showGenerateSection && this.state.doneLoading ? (
                <Button
                  className="floated left tiny grey"
                  onClick={() => this.generateShareLinks()}
                >
                  {this.state.modalButtonText}
                </Button>
              ) : null}
            </div>
          </Modal.Content>
        </Modal>
      </div>
    ) : null;
  };

  render() {
    return <div className="container">{this.renderList()}</div>;
  }
}

const presentationQuery = gql`
  query($name: String!) {
    presentationByName(name: $name) {
      id
      name
      url
      data
      cachedquery
      username
      active
      createdAt
      updatedAt
    }
  }
`;

const updateQuery = gql`
  mutation($name: String!, $presentation: PresentationPatch!) {
    updatePresentationByName(
      input: { name: $name, presentationPatch: $presentation }
    ) {
      presentation {
        data
        url
        cachedquery
        username
        active
        updatedAt
      }
    }
  }
`;

const deleteQuery = gql`
  mutation($id: Int!) {
    deletePresentationById(input: { id: $id }) {
      presentation {
        id
        name
        homePageUrl
        inventoryUrl
        fbPageId
        fbPageToken
        adAccountId
        adAccountToken
        active
      }
    }
  }
`;

const submitRepository = gql`
  mutation($presentation: PresentationInput!) {
    createPresentation(input: { presentation: $presentation }) {
      presentation {
        name
        data
        url
        active
        username
        cachedquery
      }
    }
  }
`;

const mapStateToProps = (state) => ({
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

const AdAccountListWithData = compose(
  graphql(presentationQuery, {
    options: ({ match }) => ({
      variables: {
        name: 'ALEXIA Test A Sept2017'
      }
    })
  }),

  graphql(updateQuery, {
    props: ({ mutate }) => ({
      update: (presentation) =>
        mutate({
          variables: {
            name: presentation.name,
            presentation: _.omit(presentation, [
              'id',
              'url',
              'createdAt',
              'name',
              '__typename'
            ])
          },

          updateQueries: {
            getPresentations: (prev, { mutationResult }) => {
              const newPresentation =
                mutationResult.data.updatePresentationByName;
              return newPresentation;
            }
          }
        })
    })
  }),
  graphql(deleteQuery, {
    props: ({ mutate }) => ({
      delete: (id) =>
        mutate({
          variables: {
            id
          }
        })
    })
  }),
  graphql(submitRepository, {
    props: ({ mutate }) => ({
      submit: (presentation) =>
        mutate({
          variables: {
            presentation
          }
        })
    })
  })
)(AdAccountList);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdAccountListWithData);



// WEBPACK FOOTER //
// ./src/screens/AdAccount/AdAccountList.js